

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from './NavLinks.css';
import withStyles from '../../decorators/withStyles';
import { gaEvent } from "../../utils/utils";


class NavLinks extends Component {

  render() {
    return <div className="menu-panel menu-options" data-navclass="small-menu-open">
        {this.props.children}
      <Link to={{pathname: "/about", state: {modal: true, modalTitle: "About this site", returnTo: location.pathname}}}
            onClick={() => {gaEvent('navlink', 'click', 'info');}}>
        <button className="type-small nav-btn about-btn" data-navtarget="theaboutpage" data-paneltype="modal" title="Learn about this map">
          <span className="white icon info"></span>
          <span className="small-screen">Learn about this map</span>
        </button>
      </Link>
      <a href="https://twitter.com/intent/tweet?text=See%20your%20local%20sea%20level%20and%20coastal%20flood%20risk%20on%20our%20Surging%20Seas%20Risk%20Finder%20tool&via=ClimateCentral&url=http://www.riskfinder.org" target="_blank"
         onClick={() => {gaEvent('navlink', 'click', 'twitter');}}>
        <button className="nav-btn">
          <img src="/static/Twitter_Logo.svg" style={{width: 45}} />
          <span className="small-screen">Share on Twitter</span>
        </button>
      </a>
      <a href="https://www.facebook.com/sharer.php?p%5Burl%5D=http://www.riskfinder.org/" target="_blank"
         onClick={() => {gaEvent('navlink', 'click', 'facebook');}}>
        <button className="nav-btn">
          <img src="/static/F_icon.svg" style={{width: 25, marginLeft: 12, marginRight: 6}} />
          <span className="small-screen">Share on Facebook</span>
        </button>
      </a>
      <Link to={{pathname: "/links", state: {modal: true, modalTitle: "Useful links", returnTo: location.pathname}}}
            onClick={() => {gaEvent('navlink', 'click', 'usefullinks');}}>
        <button id="extras-btn" className="nav-btn" data-navtarget="theextras" data-paneltype="modal" title="See more">
          <span className="white icon plus"></span>
          <span className="small-screen">See more</span>
        </button>
      </Link>
    </div>;
  };

}

export default withStyles(styles)(NavLinks);
